import { useState } from "react";
import { contact } from "./../../REDUX/Models/users.Model";
import "./index.scss";

export default function Contact() {
  document.title = `طورنى - تواصل معنا`;

  const [inputs, setInputs] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(
    <i className="fa-light fa-paper-plane"></i>
  );
  const [statusClass, setStatusClass] = useState("fade-in");

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    updateStatus("جارى الارسال ..");

    contact({
      subject: inputs.name,
      email: inputs.email,
      message: inputs.message,
    })
      .then(() => {
        setTimeout(() => {
          setInputs({ name: "", email: "", message: "" });
          updateStatus("تم الارسال بنجاح");

          setTimeout(() => {
            updateStatus(<i className="fa-light fa-paper-plane"></i>);
          }, 1500);
        }, 500);
      })
      .catch(() => {
        alert("خطأ ارسال الرسالة .. اعد المحاولة");
      });
  };

  const updateStatus = (newStatus) => {
    setStatusClass("fade-out");
    setTimeout(() => {
      setStatus(newStatus);
      setStatusClass("fade-in");
    }, 300);
  };

  return (
    <div className="contact">
      <div className="container">
        <h2>لا تتردد في التواصل.</h2>
        <div className="row">
          <div className="form">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="الاسم"
                value={inputs.name}
                required
                onChange={handleChange}
              />
              <input
                type="text"
                name="email"
                placeholder="البريد الالكترونى"
                value={inputs.email}
                required
                onChange={handleChange}
              />
              <textarea
                name="message"
                placeholder="ادخل رسالتك"
                value={inputs.message}
                required
                onChange={handleChange}
              />
              <button type="submit" className={`status ${statusClass}`}>
                {status}
              </button>
            </form>
          </div>
          <div className="text">
            <h3> معلومات التواصل</h3>
            <p>
              {" "}
              رقم الهاتف: <span dir="ltr">+971 55 102 9555</span>
            </p>
            <p> العنوان: الامارات العربية المتحدة </p>
            <p>
              البريد الالكترونى: <code>no-reply@develop-me.org</code>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
